import useHookForm from '../../../../../../../hooks/forms/useHookForm'
import { validationSchema } from './schema'
import { DEFAULT_VALUES } from './constants'
import { history } from '../../../../../../../utils/history'

import { createPet, updatePet } from '../../../../../../../services/pet'
import moment from 'moment'

const useForm = () => {
  const handleCreatePet = async ({ payload, alert, setLoading }) => {
    try {
      setLoading(true)
      const req = await createPet(payload)
      if (req?.data.id) {
        alert(true)
      }
      setLoading(false)
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }

  const handleUpdatePet = async ({ payload, id, alert, setLoading, updated, setVisibility }) => {
    try {
      setLoading(true)
      const req = await updatePet({ id, payload })
      if (req?.data.id) {
        updated(true)
        setVisibility(false)
      }
      setLoading(false)
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }

  const onSubmitForm = (values, params) => {
    const { owner, alert, setLoading, isEditing, id, updated, setVisibility } = params
    const { specie, birth, ...rest } = values
    const payload = {
      ...owner,
      ...(birth && { birth: moment(birth, 'DD/MM/YYYY', true).format('YYYY-MM-DD') }),
      ...rest
    }

    if (!isEditing) {
      handleCreatePet({ payload, alert, setLoading })
    } else {
      handleUpdatePet({ payload, id, alert, setLoading, updated, setVisibility })
    }
  }

  const form = useHookForm({
    onSubmitForm,
    validationSchema,
    defaultValues: DEFAULT_VALUES
  })

  return form
}

export default useForm
